import { decreaseWebsocketCounter, increaseWebsocketCounter } from '../../data/websocket-counter';
import { LSP } from '../base/types';
import { LSPWebSocketClient } from '../websocket/client';
import { Notifications, Methods, UTParamType } from './types';

export class UnitTestClient extends LSPWebSocketClient<Notifications | LSP.Notification, Methods | LSP.Method> {
  private initializedPromise: unknown;

  constructor(url: string) {
    super(url, { lazyInit: true });
    this.listen(LSP.Notification.close, () => {
      decreaseWebsocketCounter();
    });
  }

  async lazyInitialization() {
    if (!this.initializedPromise) {
      this.initializedPromise = new Promise((resolve) => {
        this.lazyInit();
        this.listen(LSP.Notification.open, () => {
          increaseWebsocketCounter();
          resolve('');
        });
      });
    }
    return this.initializedPromise;
  }

  async executeComponentTest(params: UTParamType) {
    await this.lazyInitialization();
    return await this.request({
      method: Methods.executeComponentTest,
      params
    });
  }
}
